import { mdiPlus } from "@mdi/js"
import { openOverlay } from "@kontextwerk/web-sdk/core/overlay/globalStores"
import type { InboxWorkflowRowActionProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
import CreateWorkOrderForAssignmentOverlay from "../_modules/create-work-order-for-assignment-overlay"
import type {
  AssignWorkOrderDraft,
  WorkOrderAssignmentRow,
  WorkOrderAssignmentSelection,
} from "../contract"
import {
  buildTableRowActionSet,
  type TableRowAction,
  type TableRowActionSet,
} from "@kontextwerk/web-sdk/core/layout/table"

export default function buildRowActions({
  row: runtimeRow,
  patchDraft,
  organizationId = null,
  readOnly = false,
  disabled = false,
}: InboxWorkflowRowActionProps): TableRowActionSet {
  const row = runtimeRow as unknown as WorkOrderAssignmentRow
  const tooltipContent = row.propertyId
    ? "Auftrag anlegen"
    : "Liegenschaft fehlt. Auftrag kann nicht angelegt werden."
  const isDisabled = readOnly || disabled || row.disabled || !row.propertyId || !organizationId
  const handleCreated = (selection: WorkOrderAssignmentSelection) => {
    patchDraft({
      workOrderId: selection.id,
      selectedWorkOrder: selection,
    } satisfies Partial<AssignWorkOrderDraft>)
  }
  const openCreateOverlay = () => {
    if (isDisabled || !organizationId) return

    openOverlay({
      title: "Auftrag anlegen",
      content: CreateWorkOrderForAssignmentOverlay,
      closeOnParentOpen: false,
      properties: {
        organizationId,
        row,
        onCreated: handleCreated,
      },
    })
  }
  const actions: TableRowAction[] = []

  actions.push({
    id: "action-0",
    label: "Auftrag anlegen",
    disabledReason: !row.propertyId ? tooltipContent : undefined,
    onClick: () => openCreateOverlay(),
    icon: mdiPlus,
    disabled: isDisabled,
    tooltip: tooltipContent,
    testId: "inbox.assignWorkOrder.create",
  })

  return buildTableRowActionSet(actions, { primaryId: null, inlineIds: ["action-0"] })
}
